import DropdownButtonForSearch from "../Dropdowns/DropdownButtonForSearch";
import InputField from "../inputfields/InputField";
import { useEffect, useState } from "react";
import geoInfo from "../utils/geoInfo";
import { searchFunction } from "../commonfunctions/searchFunction";
import * as countries from 'countries-list';

interface InputValues {
  country: string;
  province?: string;
  region?: string;
  district?: string;
  postal_code?: string;
  nationality?: string;
}

interface CountryProps {
  inputValues: InputValues;
  errorMessage: InputValues;
  onInputChange: (id: string, value: string) => void;
  disableAll: boolean;
  editLoading: boolean;
  tabIndex: number;
  mapping: boolean;
  type: string;
  labelName: string;
  id: string;
  RequiredPostalCode?: boolean;
}
const countriesList = Object.values(countries.countries).map((country: { name: string }) => country.name);


export default function Country({ type, inputValues, onInputChange, errorMessage, labelName, id, disableAll, editLoading, tabIndex, mapping, RequiredPostalCode }: CountryProps) {
  const { country, province, region, district, postal_code, nationality } = inputValues;
  const provinceList = [...new Set(geoInfo.map((item) => item.Province))];
  const [countries, setCountries] = useState(countriesList);
  const [provinces, setSetProvinces] = useState(provinceList);
  const [districts, setDistricts] = useState<string[]>([]);
  const [districtList, setDistrictList] = useState<string[]>([]);
  const getListOfData = (
    data: { [key: string]: any }[],
    selectedValue: string,
    key: string,
    requiredKey: string
  ): string[] => {
    return Array.from(
      new Set(
        data
          .filter((item) => item[key] === selectedValue)
          .map((item) => item[requiredKey])
      )
    );
  };

  const inputFieldsConfig = {
    province: {
      labelName: "Province (State)",
      id: "province",
      tabIndex: tabIndex + 2,
      required: true,
      disabled: disableAll,
      errorMessage: errorMessage.province,
      value: province,
    },
    region: {
      labelName: "Region",
      id: "region",
      tabIndex: tabIndex + 3,
      required: false || mapping,
      disabled: disableAll,
      errorMessage: errorMessage.region,
      value: region,
    },
    district: {
      labelName: "District",
      id: "district",
      tabIndex: tabIndex + 4,
      required: false,
      disabled: disableAll,
      errorMessage: errorMessage.district,
      value: district,
    },
    // Conditionally include postal_code
    ...(!RequiredPostalCode ? {} : {
      postal_code: {
        labelName: "Postal Code",
        id: "postal_code",
        tabIndex: tabIndex + 5,
        required: true,
        disabled: disableAll,
        errorMessage: errorMessage.postal_code,
        value: postal_code,
      },
    })
  };

  const handleSearchValue = (value: string, id: string) => {
    switch (id) {
      case "country":
      case "nationality":
      case "issuer_country":
        setCountries(searchFunction(value, countriesList));
        break;
      case "province":
        setSetProvinces(searchFunction(value, provinceList));
        break;
      case "district":
        setDistricts(searchFunction(value, districtList));
        break;
      default:
        break;
    }
  };
  const handleInputChange = (id: string, value: string) => {
    onInputChange(id, value);
    if (id === 'nationality') {
      onInputChange(id, value);
    }
    if (id === "country" && value.toLocaleLowerCase() === "afghanistan" && country.toLocaleLowerCase() !== 'afghanistan') {
      onInputChange("province", "");
      onInputChange("region", "");
      onInputChange("district", "");
      onInputChange("postal_code", "");
    }
    if (country.toLocaleLowerCase() === "afghanistan") {
      switch (id) {
        case "country":
          if (country.toLocaleLowerCase() !== value.toLocaleLowerCase()) {
            onInputChange("province", "");
            onInputChange("region", "");
            onInputChange("district", "");
            onInputChange("postal_code", "");
          }
          break;
        case "province":
          if (province !== value) {
            const selectedRegion = getListOfData(
              geoInfo,
              value,
              "Province",
              "Region Name"
            );
            onInputChange("region", selectedRegion[0]);
            const selectedDistrict = getListOfData(
              geoInfo,
              value,
              "Province",
              "District"
            );
            onInputChange("postal_code", "");
            onInputChange("district", "");
            setDistricts(selectedDistrict);
            setDistrictList(selectedDistrict);
          }
          break;
        case "district":
          if (district !== value) {
            const selectedCode = getListOfData(
              geoInfo,
              value,
              "District",
              "Region Code"
            );
            onInputChange("postal_code", selectedCode[0]);
          }
          break;
        default:
          break;
      }
    }
  };
  useEffect(() => {
    if (province && province !== '') {
      const selectedDistrict = getListOfData(
        geoInfo,
        province,
        "Province",
        "District"
      );
      setDistricts(selectedDistrict);
    }
  }, [province]);
  const getInputs = () => {
    switch (country.toLocaleLowerCase()) {
      case "afghanistan":
        return (
          <>
            <DropdownButtonForSearch
              labelName="Province (State)"
              id="province"
              errorMessage={errorMessage.province}
              onChange={handleInputChange}
              required={true}
              tabIndex={tabIndex + 2}
              editLoading={editLoading}
              options={provinces}
              selectedValue={province}
              handleSearchValue={handleSearchValue}
              disabled={disableAll}
              modalStyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            <InputField
              inputItem={{
                labelName: "Region",
                id: "region",
              }}
              placeholder={country === "Afghanistan" ? 'Auto-filled based on province' : ''}
              editLoading={editLoading}
              errorMessage={errorMessage.region}
              value={region}
              required={mapping}
              disabled={true}
              tabIndex={tabIndex + 3}
              maindivstyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            <DropdownButtonForSearch
              labelName="District"
              id="district"
              errorMessage={errorMessage.district}
              required={true}
              tabIndex={tabIndex + 4}
              editLoading={editLoading}
              options={districts}
              disabled={!province || disableAll}
              selectedValue={district}
              onChange={handleInputChange}
              handleSearchValue={handleSearchValue}
              modalStyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />
            {RequiredPostalCode && <InputField
              inputItem={{
                labelName: "Postal Code",
                id: "postal_code",
              }}
              placeholder={country === "Afghanistan" ? 'Auto-filled  based on district' : ''}
              errorMessage={errorMessage.postal_code}
              value={postal_code}
              disabled={true}
              editLoading={editLoading}
              tabIndex={tabIndex + 5}
              maindivstyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
              className={mapping ? 'w-full' : ''}
            />}
          </>
        );
      default:
        return (
          <>
            {Object.entries(inputFieldsConfig).map(([key, config]) => (
              <InputField
                key={key}
                inputItem={{ labelName: config.labelName, id: config.id }}
                tabIndex={config.tabIndex}
                required={config.required}
                disabled={config.disabled}
                errorMessage={config.errorMessage}
                editLoading={editLoading}
                value={config.value}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleInputChange(config.id, event.target.value)
                }
                maindivstyle={mapping ? 'px-5 w-1/3 mb-5' : ''}
                className={mapping ? 'w-full' : ''}
              />
            ))}
          </>
        );
    }
  };
  return (
    <>
      <DropdownButtonForSearch
        labelName={labelName}
        id={id}
        errorMessage={errorMessage.country}
        onChange={handleInputChange}
        required={true}
        tabIndex={tabIndex + 1}
        editLoading={editLoading}
        options={countries}
        disabled={disableAll}
        selectedValue={id === 'country' ? country : nationality}
        handleSearchValue={handleSearchValue}
        modalStyle={mapping ? id === 'country' ? 'px-5 w-1/3' : '' : ''}
        className={mapping ? 'w-full' : ''}
      />
      {(country && type === 'country_type') && getInputs()}
    </>
  );
}
